import React from 'react'
import PropTypes from 'prop-types'
import withStyles from 'react-jss'

import styles from './info-text-style'

const InfoText = props =>
  <p className={props.classes.infoText}>
    <span dangerouslySetInnerHTML={{ __html: props.html }} />
  </p>

InfoText.propTypes = {
  classes: PropTypes.object.isRequired,
  html: PropTypes.string.isRequired,
}

export default withStyles(styles)(InfoText)
